module.exports = fox => {
	const SHOW_CAPTCHA_ATTEMPTS = 5;
	const LS_LABEL = '_auth_fails_';

	const emptyValidator = (value = '') => ({
		result: value.length > 0,
		message: 'Cannot be empty'
	});

	fox.registerWidget('Common_LoginForm', {
		configure() {
			this.registerOptions('', {
				autoRender: true,
				useCaptcha: false,
				captchaContainer: '#captcha',
				captchaAlias: 'autumnNew',
				widgets: {
					form: {
						widget: 'DomForm',
						valuePostProcessing: [
							(value = '') => encodeURIComponent(fox.trim(value))
						],
						elements: {
							'login.validators': [
								emptyValidator
							],
							'password.validators': [
								emptyValidator
							]
						}
					}
				},
				handleDom: {
					reloadCapcha: {
						target: '#reload-captcha',
						callback: (node, alias, captcha) => captcha.loadCaptcha()
					},
				}
			});

			this.callParent('configure', arguments);
		},

		_requireCallbackFromOption(optionName) {
			const callback = this.requireOption(optionName);

			if (typeof callback !== 'function')
				throw new TypeError(`[${optionName}] must be an function`);

			return callback;
		},

		init() {
			const useCaptcha = this.getOption('useCaptcha');

			let failsCount = 0;
			Object.defineProperty(this, '_failsCount', {
				set: (value) => {
					failsCount = value;

					localStorage.setItem(LS_LABEL, JSON.stringify({
						value: failsCount,
						timestamp: new Date().getTime()
					}));
				},
				get: () => {
					if (failsCount === 0) {
						let fromStorage = localStorage.getItem(LS_LABEL);
						const now = new Date().getTime();

						if (fromStorage !== null) {
							fromStorage = JSON.parse(fromStorage);
							
							if (now - fromStorage.timestamp < 1000 * 60 * 30)
								failsCount = fromStorage.value;
						}
					}

					return failsCount;
				}
			});

			this.api = this._requireCallbackFromOption('configureApi')();
			this.prepareParams = this._requireCallbackFromOption('prepareParamsCallback');
			this.loginSuccess = this._requireCallbackFromOption('loginSuccessCallback');
			this.loginFailed = this._requireCallbackFromOption('loginFailedCallback');
			this.showCaptcha = useCaptcha && this._requireCallbackFromOption('showCaptchaCallback') || (() => null);

			if (useCaptcha) {
				this.embedWidget('captcha', 'Captcha', {
					'embed.container': this.getOption('captchaContainer'),
					captchaAlias: this.getOption('captchaAlias')
				});

				this.registerOptions('#form', {
					elements: {
						'captcha.validators': [
							(value, validator) => {
								setTimeout(() => validator.resetResultCache(value), 10);

								if (this._failsCount > SHOW_CAPTCHA_ATTEMPTS)
									return emptyValidator(value);
								
								return { result: true };
							}
						]
					}
				});
			}

			this.callParent('init', arguments);
		},

		login(rest) {
			const form = this.rwom1('#form');
			const captcha = this.wom1('#captcha')

			return form.submit().then(result => {
				if (!result)
					return false;

				if (this._failsCount > SHOW_CAPTCHA_ATTEMPTS) {
					result = { ...result, captchaId: captcha.captchaId }
				}

				return this.api.psend(this.prepareParams(result, rest))
					.then(({ params }) => {
						this._failsCount = 0;
						return this.loginSuccess(params, rest);
					}).catch(error => {
						const { params: { answer : { data }}} = error;

						this._failsCount = data || this._failsCount;

						if (this._failsCount > SHOW_CAPTCHA_ATTEMPTS) {
							this.showCaptcha();
							captcha.loadCaptcha();
						}

						return this.loginFailed(error, rest);
					});
			});
		},

		addedToDom() {
			if (this._failsCount > SHOW_CAPTCHA_ATTEMPTS)
				this.showCaptcha();
		}
	});
}



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/widget/LoginForm.es.js